import {
  doesToolSupportPromptInstruction,
  GENERATION_TOOL,
  type GenerationTool,
  isMultiPromptTool,
  prepareToolListForBackend,
} from 'src/data/generationTool';
import { isDocumentProjectType } from 'src/data/project';
import { getGenericTemplates } from 'src/data/template';

const TOOLS_ADD = [GENERATION_TOOL.freestyle];
const TOOLS_REMOVE: GenerationTool[] = [
  GENERATION_TOOL.basicBlogIdeas,
  GENERATION_TOOL.basicProductReview,
  GENERATION_TOOL.basicPerfectHeadline,
];

export const prepareToolList = (): Record<string, string> => {
  // Get all generic templates that are available on the "project template" popup
  const genericTemplates = getGenericTemplates();

  // Take only "document" non-"multi-prompt" tools
  const documentTools = genericTemplates
    .filter(
      ({ projectType, generationTool }) =>
        isDocumentProjectType(projectType) && !isMultiPromptTool(generationTool)
    )
    .map(({ generationTool }) => generationTool);

  // BE also needs some additional tools added and some removed
  const finishedList: GenerationTool[] = [...documentTools, ...TOOLS_ADD]
    .filter((tool) => !TOOLS_REMOVE.includes(tool))
    // Also remove tools that don't support prompt instruction
    .filter((tool) => doesToolSupportPromptInstruction(tool));

  // Convert tools to backend format
  return prepareToolListForBackend(finishedList);
};
